// Warning page shown to users when they are not using Chrome.

import { FC } from 'react';
import { Button, Typography } from '@mui/material';
import { redirectToLogin } from 'packages/lib/auth';

export const BrowserNotSupported: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <section
      className="content-wide"
      style={{
        padding: '200px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <div>
        <Typography variant="h1">Chrome required</Typography>
        <Typography variant="subtitle1">
          Your web browser is not supported by ml.motional.com. Please use
          Chrome. <br />
          You may attempt to continue to login, but you will likely run into
          problems.
        </Typography>
        <br />
        <Button
          variant="outlined"
          onClick={(): void => {
            void redirectToLogin();
          }}
        >
          Ignore and Proceed to Login
        </Button>
      </div>
    </section>
  );
};

export default BrowserNotSupported;
